var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 14.7734C8.08594 14.7734 7.85156 14.6641 7.6875 14.5625C3.28125 11.75 0.492188 8.47656 0.492188 5.14844C0.492188 2.38281 2.39062 0.429688 4.84375 0.429688C6.36719 0.429688 7.55469 1.28125 8.25 2.5625C8.96094 1.27344 10.1328 0.429688 11.6562 0.429688C14.1094 0.429688 16.0078 2.38281 16.0078 5.14844C16.0078 8.47656 13.2188 11.75 8.82031 14.5625C8.64844 14.6641 8.41406 14.7734 8.25 14.7734Z",
    fill: "#9C85F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiked);
export default __webpack_public_path__ + "static/media/liked.4cb8e9aed4d02167f4de9a49a087694b.svg";
export { ForwardRef as ReactComponent };